export default "__VITE_ASSET__Cbd2HisB__";